import classNames from "classnames";
import { useContext, useState } from "react";
import { CsTournamentTimeline } from "./CsTournamentTimeline";
import { DotaTournamentTimeline } from "./DotaTournamentTimeline";
import { GameId } from "@portal-frontend-ssr/blast-api";
import { GameIdContext } from "@portal-frontend-ssr/providers";
import { GameIcon } from "@portal-frontend-ssr/navbar/src/components/GameIcon";
import { gameTitles } from "@portal-frontend-ssr/navbar";
import { TournamentTimeline } from "@portal-frontend-ssr/blast-data-api";

export const CombinedTournamentTimeline = ({ data }: { data: TournamentTimeline }) => {
  const [selected, setSelected] = useState<GameId>("cs");
  const { enabledGames } = useContext(GameIdContext);

  return (
    <div>
      <div className="mb-5 flex gap-1">
        <button
          className={classNames(
            "group flex h-9 w-full items-center justify-center rounded-small border transition-all",
            {
              "border-foreground-100 bg-background-90 disabled:border-foreground-100 disabled:bg-background-90":
                selected === "cs",
              "border-neutral bg-background-100 hover:border-foreground-90 hover:bg-background-95": selected !== "cs",
            },
          )}
          disabled={selected === "cs"}
          onClick={() => setSelected("cs")}
        >
          <div
            className={classNames("flex h-5 items-center gap-3 transition-all", {
              "opacity-80 group-hover:opacity-90": selected !== "cs",
              "opacity-100": selected === "cs",
            })}
          >
            <GameIcon gameId="cs" width={20} />
            <span className="text-white font-style-label-l3">{gameTitles["cs"]}</span>
          </div>
        </button>
        {enabledGames.includes("dota") && (
          <button
            className={classNames(
              "group flex h-9 w-full items-center justify-center rounded-small border transition-all",
              {
                "border-foreground-100 bg-background-90 disabled:border-foreground-100 disabled:bg-background-90":
                  selected === "dota",
                "border-neutral bg-background-100 hover:border-foreground-90 hover:bg-background-95":
                  selected !== "dota",
              },
            )}
            disabled={selected === "dota"}
            onClick={() => setSelected("dota")}
          >
            <div
              className={classNames("flex h-5 items-center gap-3 transition-all", {
                "opacity-80 group-hover:opacity-90": selected !== "dota",
                "opacity-100": selected === "dota",
              })}
            >
              <GameIcon gameId="dota" width={20} />
              <span className="text-white font-style-label-l3">{gameTitles["dota"]}</span>
            </div>
          </button>
        )}
      </div>
      <div aria-live="polite">
        {selected === "cs" && <CsTournamentTimeline data={data} />}
        {selected === "dota" && <DotaTournamentTimeline data={data} />}
      </div>
    </div>
  );
};
